import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import InfoPill from '../infoPill';
import Icon from '../icon';
import Animate from '../animate';
import { ColorNames } from '../../../constants/colorVars';
const FADE_TIMEOUT_MS = 300;
export var ChipColor;
(function (ChipColor) {
    ChipColor["Info"] = "info";
    ChipColor["Success"] = "success";
    ChipColor["Caution"] = "caution";
    ChipColor["Error"] = "error";
    ChipColor["Purple"] = "purple";
    ChipColor["Gray"] = "gray";
})(ChipColor || (ChipColor = {}));
const colorToExtraLight = {
    [ChipColor.Info]: ColorNames.InfoExtraLight,
    [ChipColor.Success]: ColorNames.SuccessExtraLight,
    [ChipColor.Caution]: ColorNames.CautionExtraLight,
    [ChipColor.Error]: ColorNames.ErrorExtraLight,
    [ChipColor.Purple]: ColorNames.PurpleExtraLight,
    [ChipColor.Gray]: ColorNames.White,
};
const colorToLight = {
    [ChipColor.Info]: ColorNames.InfoLight,
    [ChipColor.Success]: ColorNames.SuccessLight,
    [ChipColor.Caution]: ColorNames.CautionLight,
    [ChipColor.Error]: ColorNames.ErrorLight,
    [ChipColor.Purple]: ColorNames.PurpleLight,
    [ChipColor.Gray]: ColorNames.GrayLight,
};
const Chip = ({ content, size = 'medium', type = 'filter', selectionStyle: _selectionStyle, isSelected: _isSelected = false, disabled = false, onClick, color, className, style, elmId = 'chip', }) => {
    const useDefaultColors = !color;
    const [isVisible, setIsVisible] = React.useState(true);
    const isSelected = _isSelected || type === 'input';
    const selectionStyle = _selectionStyle || (type === 'input' ? 'light' : 'dark');
    const includeBorder = !isSelected;
    let backgroundColor;
    let foregroundColor;
    if (!isSelected) {
        backgroundColor =
            colorToExtraLight[useDefaultColors ? ChipColor.Gray : color];
        foregroundColor = color;
    }
    else {
        const selectionColor = useDefaultColors ? ChipColor.Info : color;
        if (selectionStyle === 'dark') {
            backgroundColor = selectionColor;
            foregroundColor = ColorNames.White;
        }
        else {
            backgroundColor = useDefaultColors
                ? colorToExtraLight[selectionColor]
                : colorToLight[selectionColor];
            foregroundColor = selectionColor;
        }
    }
    const handleClick = (e) => {
        if (!disabled && onClick) {
            if (type === 'filter')
                onClick(e);
            else if (type === 'input') {
                setIsVisible(false);
                setTimeout(() => {
                    onClick(e);
                }, FADE_TIMEOUT_MS);
            }
        }
    };
    return (_jsx("div", { className: className, style: style, "data-elm-id": elmId, onClick: type === 'filter' ? handleClick : undefined, tabIndex: disabled ? -1 : 0, role: 'button', "aria-pressed": isSelected, "aria-disabled": disabled, children: _jsx(Animate.FadeInOut, { isVisible: isVisible, duration: FADE_TIMEOUT_MS, children: _jsx(InfoPill, { content: content, size: size, backgroundColor: backgroundColor, foregroundColor: foregroundColor, includeBorder: includeBorder, interactive: type === 'input' ? 'icon' : 'button', disabled: disabled, iconOnRight: type !== 'filter', icon: isSelected ? (_jsx(Icon, { elmId: `${elmId}-${type === 'filter' ? 'check' : 'close'}`, fitted: true, name: type === 'filter' ? 'check' : 'xmark', iconStyle: 'solid', color: foregroundColor, onClick: type === 'input' ? handleClick : undefined })) : undefined }) }) }));
};
export default Chip;
//# sourceMappingURL=index.js.map